var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14 14.665H2a.504.504 0 0 1-.5-.5c0-.273.227-.5.5-.5h12c.273 0 .5.227.5.5s-.227.5-.5.5zM12.68 2.32c-1.294-1.294-2.56-1.327-3.887 0l-.806.806a.278.278 0 0 0-.067.267 5.419 5.419 0 0 0 3.686 3.686c.027.006.054.013.08.013.074 0 .14-.026.194-.08l.8-.806c.66-.654.98-1.287.98-1.927.006-.66-.314-1.3-.98-1.96z",
    fill: "#1080FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M10.406 7.686a5.866 5.866 0 0 1-.987-.573 4.025 4.025 0 0 1-.373-.287.814.814 0 0 1-.113-.1 5.638 5.638 0 0 1-.687-.693c-.02-.013-.053-.06-.1-.12-.066-.08-.18-.213-.28-.367-.08-.1-.173-.246-.26-.393-.106-.18-.2-.36-.293-.547a7.433 7.433 0 0 1-.233-.573L2.893 8.22a.802.802 0 0 0-.186.367l-.36 2.553c-.067.453.06.88.34 1.167.24.233.573.36.933.36.08 0 .16-.007.24-.02l2.56-.36c.12-.02.286-.1.366-.187l4.187-4.186a9.1 9.1 0 0 1-.567-.227z",
    fill: "#1080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerEdit);
export default __webpack_public_path__ + "static/media/customerEdit.8c876f19b5ae7422097b51017b07878a.svg";
export { ForwardRef as ReactComponent };